<template>
  <thead>
    <tr>
      <dataset-th
        v-for="col in columns"
        :key="col.key"
        :column="col"
        :sort="sort"
        :loading="loading"
        @click="() => setSort(col.key)"
        :checkedrows.sync="checkedrows"
        :rows="rows"
      />
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'Datasethead',
  components: {
    DatasetTh: require('./dataset-th').default,
    OrderIcon: require('./head/order-icon').default,
  },
  props: {
    // column list
    columns: { type: Array, default: () => [] },
    // sort object
    sort: { type: Object, default: () => ({}) },
    // function pass from main dataset to sort field
    setSort: { type: Function, default: () => {} },
    loading: { type: Boolean, default: () => false },
    rows: {type: Array, default: () => []},
    checkedrows: {type: Array, default: () => []}
  },
}
</script>
